import * as React from "react";
import { get } from "lodash";
import Icon from "@launchos/plugins/webcomponents/v2/Icon";

/**
 * A component that shows a LIVE date picker field or tools for configuring the date picker's look, feel, and behavior
 */
export function LiveDateField(props) {
  const { onBlur } = props;
  const { labelStyle = {}, descriptionStyle = {}, iconStyle = {}, inputStyle = {} } = props.styles;
  return (<div data-testid="FormBuilder-FormFields-DateField-LIVE">
    {/* {props.label && <div style={labelStyle || {}}>{props.label}</div>} */}
    {props.description && <div style={descriptionStyle}>{props.description}</div>}
    {props.icon && <span style={{
      position: "absolute",
      paddingTop: get(iconStyle, 'padding', 0)
    }} ref={props.ref}>
      <Icon type={props.icon} style={{
        ...iconStyle,
        marginTop: 5,
        marginLeft: 1,
        paddingTop: 0
      }} />
    </span>}
    <input style={{
      ...inputStyle,
      ...(props.icon ? {
        padding: `${props.inputPadding} ${props.inputPadding} ${props.inputPadding} ${get(props.iconDimensions, 'width')}px`
      } : {})
    }} type="date" value={props.defaultValue} onChange={props.handleChange} onBlur={onBlur} />
  </div>);
}

export default LiveDateField